export default __webpack_public_path__ + "static/ramanSharma10-b8cc0f3f3255a329e61516b61624fc11.jpg";